export const UserFriendlyErrorMessages = {
    409: 'This phone number is already in use - please try another.',
};
